import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row items-end Rotis q-mb-xl" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 static no-print" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 static print" }, null, -1)
const _hoisted_4 = { class: "col text-progression-bar bg-white no-padding" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = {
  class: "col bg-primary q-pl-md q-pr-xl q-pt-sm q-pb-sm",
  style: {"min-width":"270px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_8 = {
  key: 0,
  registered: "",
  style: {"background":"#55c970"},
  class: "text-subtitle1 q-pa-lg q-my-xl text-white error-msg row items-center"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "text-primary text-h5 q-mb-lg" }
const _hoisted_11 = { class: "q-mb-xl" }
const _hoisted_12 = { class: "row q-mb-xl" }
const _hoisted_13 = { class: "bg-secondary text-white q-px-xl q-py-sm" }
const _hoisted_14 = { class: "row items-center" }
const _hoisted_15 = { class: "q-mb-sm col q-pr-sm" }
const _hoisted_16 = { class: "q-mb-sm col q-pr-sm" }
const _hoisted_17 = {
  class: "PurpleToWhite q-mb-sm",
  style: {"width":"54px"}
}
const _hoisted_18 = {
  key: 1,
  class: "text-negative q-mb-sm q-mx-md"
}
const _hoisted_19 = {
  class: "meds-field q-mb-lg row q-pa-xs content-start",
  style: {"gap":"5px"}
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 q-pa-sm" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-6 q-pa-sm" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-6 q-pa-sm" }
const _hoisted_26 = { class: "col-6 q-pa-sm" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 q-pa-sm" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-6 q-pa-sm" }
const _hoisted_31 = { class: "col-6 q-pa-sm" }
const _hoisted_32 = { class: "row q-mb-xl" }
const _hoisted_33 = { class: "col-12 q-pa-sm" }
const _hoisted_34 = { class: "row justify-between q-px-sm no-wrap" }
const _hoisted_35 = { class: "PurpleToWhite col-xs col-sm-4 col-md-2 row justify-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_37 = { class: "PurpleToWhite col-xs col-sm-4 col-md-2 row justify-center" }
const _hoisted_38 = {
  key: 2,
  class: "col row justify-end text-negative q-mb-sm q-mr-xs"
}
const _hoisted_39 = { class: "col-xs col-sm-4 col-md-2 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GreenTitle = _resolveComponent("GreenTitle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Wizard.Request')), 1),
          _hoisted_7
        ])
      ])
    ]),
    (_ctx.validationMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t(_ctx.validationMessage)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PresentationSection.Title')), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PresentationSection.Resume')), 1)
    ]),
    _createVNode(_component_GreenTitle, {
      class: "q-mb-sm",
      title: _ctx.$t('Compatibility.CompatibilityRequest.CarrierSolution')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.transport?.name), 1)
    ]),
    _createVNode(_component_GreenTitle, {
      class: "q-mb-sm",
      title: _ctx.$t('Compatibility.CompatibilityRequest.DrugAdditive')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_q_input, {
          label: _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.TradeNameAddition'),
          filled: "",
          borderless: "",
          modelValue: _ctx.inputName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputName) = $event)),
          onKeyup: _withKeys(_ctx.addInput, ["enter"])
        }, _createSlots({ _: 2 }, [
          (_ctx.inputName)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.inputName = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["label", "modelValue", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_q_input, {
          label: _ctx.$t('Compatibility.PhysicoChemicalCompatibility.DrugAdditiveTab.ActiveIngredient'),
          filled: "",
          borderless: "",
          modelValue: _ctx.inputAgent,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputAgent) = $event)),
          onKeyup: _withKeys(_ctx.addInput, ["enter"])
        }, _createSlots({ _: 2 }, [
          (_ctx.inputAgent)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.inputAgent = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["label", "modelValue", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          onClick: _cache[4] || (_cache[4] = () => { _ctx.addInput() }),
          style: {"width":"100%","height":"54px"},
          class: "text-subtitle2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "add" })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.errorMessage.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newRequest.medicins, (medicin, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "bg-grey row items-center q-pl-md q-pr-sm",
          style: {"height":"28px","border-radius":"50px"}
        }, [
          _createElementVNode("span", null, [
            _createElementVNode("b", null, _toDisplayString(medicin.name + ' - ' + medicin.activeAgent), 1)
          ]),
          _createVNode(_component_q_icon, {
            name: "close",
            class: "cursor-pointer q-ml-sm",
            onClick: ($event: any) => (_ctx.removeInput(index))
          }, null, 8, ["onClick"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.ApplicationDetails')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          autogrow: "",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.comment,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newRequest.comment) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.comment)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.newRequest.comment = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.SpitalInstitution')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.institute,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newRequest.institute) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.institute)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.newRequest.institute = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.FirstName')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.firstName,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newRequest.firstName) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.firstName)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.newRequest.firstName = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.LastName')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.lastName,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newRequest.lastName) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.lastName)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.newRequest.lastName = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Street')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.address.street,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newRequest.address.street) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.address.street)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.newRequest.address.street = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.PLZ')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.address.postalCode,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newRequest.address.postalCode) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.address.postalCode)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.newRequest.address.postalCode = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.Location')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.address.city,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newRequest.address.city) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.address.city)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.newRequest.address.city = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Compatibility.CompatibilityRequest.EmailAddress')), 1),
        _createVNode(_component_q_input, {
          class: "q-my-sm",
          filled: "",
          borderless: "",
          modelValue: _ctx.newRequest.email,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newRequest.email) = $event))
        }, _createSlots({ _: 2 }, [
          (_ctx.newRequest.email)
            ? {
                name: "append",
                fn: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "cancel",
                    onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.newRequest.email = ''), ["stop"])),
                    class: "cursor-pointer"
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          onClick: _cache[21] || (_cache[21] = () => { _ctx.closeRequestForm() }),
          class: "col text-bold text-subtitle2 ellipsis"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString('< ' + _ctx.$t('PreviousButton')), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          flat: "",
          onClick: _cache[22] || (_cache[22] = () => { _ctx.showRequest() }),
          class: "col text-bold text-subtitle2 ellipsis"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Send')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.errorMessageSend)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t(_ctx.errorMessageSend)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}